{
  "title": "Rapoarte",
  "subtitle": "Rapoarte financiare și despre cursanți pentru o perioadă fixă.",
  "exportCsv": "Exportă CSV",
  "periods": {
    "month": "Luna aceasta",
    "lastMonth": "Luna trecută",
    "quarter": "Trimestrul acesta",
    "lastQuarter": "Trimestrul trecut",
    "year": "Anul acesta",
    "lastYear": "Anul trecut",
    "all": "Tot timpul"
  },
  "financial": {
    "heading": "Financiar",
    "income": "Venituri",
    "expenses": "Cheltuieli",
    "net": "Net",
    "outstanding": "Restanțe",
    "indicative": "estimativ · la cursul curent",
    "incomeByCategory": "Venituri pe categorii",
    "expenseByCategory": "Cheltuieli pe categorii",
    "netOverTime": "Profit / pierdere în timp",
    "noIncome": "Niciun venit în această perioadă.",
    "noExpenses": "Nicio cheltuială în această perioadă.",
    "noData": "Nicio activitate financiară în această perioadă.",
    "month": "Luna"
  },
  "outstanding": {
    "heading": "Plăți restante",
    "student": "Cursant",
    "fee": "Taxă",
    "status": "Statut",
    "due": "Scadență",
    "amount": "Sumă",
    "none": "Nicio restanță.",
    "pending": "În așteptare",
    "overdue": "Întârziate",
    "total": "Total"
  },
  "students": {
    "heading": "Cursanți",
    "countOverTime": "Cursanți activi în timp",
    "retention": "Retenție",
    "byLevel": "După nivel",
    "byDanceType": "După tipul de dans",
    "byClass": "După clasă",
    "count": "Cursanți",
    "none": "Încă nu există date.",
    "retention3": "3 luni",
    "retention6": "6 luni",
    "retention12": "12 luni"
  }
}
